import Vue from 'vue'
import VueRouter from 'vue-router'

import store from "../store/index.js";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component() {
      return import(/* webpackChunkName: "welcome" */ '../views/Welcome.vue');
    },
    meta: {
      allowAnonymous: true,
      level: 1,
    },
    name: 'welcome',
  },
  {
    path: '/home',
    component() {
      return import(/* webpackChunkName: "home" */ '../views/Home.vue');
    },
    meta: {
      level: 10,
    },
    name: 'home',
  },
  {
    path: '/home/settings',
    component() {
      return import(/* webpackChunkName: "challenge-settings" */ '../views/us/ChallengeSettings.vue');
    },
    meta: {
      level: 20,
    },
    name: 'challenge_settings',
  },
  /*** PLAY SECTION ***/
  {
    path: '/play',
    component() {
      return import(/* webpackChunkName: "play" */ '../views/Play.vue');
    },
    meta: {
      level: 12,
    },
    name: 'play',
  },
  {
    path: '/play/bedroomgame',
    component() {
      return import(/* webpackChunkName: "bedroomgame" */ '../views/play/BedroomGame.vue');
    },
    meta: {
      level: 21,
    },
    name: 'bedroomgame',
    props: true,
  },
  {
    path: '/play/playlist',
    component() {
      return import(/* webpackChunkName: "playlists" */ '../views/play/PlayListList.vue');
    },
    meta: {
      level: 21,
    },
    name: 'playlist',
  },
  {
    path: '/play/playlist/list/:id',
    component() {
      return import(/* webpackChunkName: "playlists-detail" */ '../views/play/PlayListDetail.vue');
    },
    meta: {
      level: 31,
    },
    name: 'playlist_detail',
    props: true,
  },
  {
    path: "/play/battlestrip",
    component() {
      return import(/* webpackChunkName: "battlestrip-intro" */ '../views/play/battlestrip/Intro.vue');
    },
    meta: {
      level: 21,
    },
    name: "battlestrip",
  },
  {
    path: "/play/battlestrip/game",
    component() {
      return import(/* webpackChunkName: "battlestrip-game" */ "../views/play/battlestrip/Game.vue");
    },
    meta: {
      level: 22,
    },
    name: "battlestrip_game"
  },
  {
    path: "/play/invites",
    component() {
      return import(/* webpackChunkName: "invites" */ '../views/play/Invites.vue');
    },
    meta: {
      level: 24,
    },
    name: "invites",
  },
  {
    path: "/play/twister",
    component() {
      return import(/* webpackChunkName: "twister" */ '../views/play/Twister.vue');
    },
    meta: {
      level: 25,
    },
    name: "twister",
  },
  {
    path: "/play/connect4play",
    component() {
      return import(/* webpackChunkName: "connect4play" */ '../views/play/connect4play/Main.vue');
    },
    meta: {
      level: 26,
    },
    name: "connect4play",
  },
  {
    path: "/play/charades",
    component() {
      return import(/* webpackChunkName: "charades" */ '../views/play/Charades');
    },
    meta: {
      level: 27,
    },
    name: "charades",
  },
  /*** DISCOVER  ***/
  {
    path: '/discover',
    component() {
      return import(/* webpackChunkName: "discover" */ '../views/Discover.vue');
    },
    meta: {
      level: 14,
    },
    name: 'discover',
  },
  {
    path: '/discover/exploration-list',
    component() {
      return import(/* webpackChunkName: "exploration-list" */ '../views/discover/ExplorationList.vue');
    },
    meta: {
      level: 21,
    },
    name: 'exploration_list',
  },
  {
    path: '/discover/exploration-list/pack/:packId',
    component() {
      return import(/* webpackChunkName: "exploration-pack" */ '../views/discover/ExplorationPack.vue');
    },
    meta: {
      level: 31,
    },
    name: 'exploration_pack',
    props: true,
  },
  {
    path: '/discover/exploration-list/compare-pack/:packId',
    component() {
      return import(/* webpackChunkName: "exploration-compare-pack" */ '../views/discover/ExplorationComparePack.vue');
    },
    meta: {
      level: 31,
    },
    name: 'exploration_compare_pack',
    props: true,
  },
  {
    path: '/discover/conversation-starters',
    component() {
      return import(/* webpackChunkName: "conversation-starters" */ '../views/discover/ConversationStarters.vue');
    },
    meta: {
      level: 22,
    },
    name: 'conversation_starters',
    props: true,
  },
  {
    path: '/discover/bedroom-language',
    component() {
      return import(/* webpackChunkName: "bedroom-language" */ '../views/discover/BedroomLanguage.vue');
    },
    meta: {
      level: 23,
    },
    name: 'bedroom_language',
  },
  {
    path: '/discover/date-ideas',
    component() {
      return import(/* webpackChunkName: "date-ideas" */ '../views/discover/DateIdeasList.vue');
    },
    meta: {
      level: 24,
    },
    name: 'dateideas_list',
  },
  {
    path: '/discover/date-ideas/:id',
    component() {
      return import(/* webpackChunkName: "date-ideas-detail" */ '../views/discover/DateIdeasDetail.vue');
    },
    meta: {
      level: 34,
    },
    name: 'dateideas_detail',
    props: true,
  },
  {
    path: '/discover/stories',
    component() {
      return import(/* webpackChunkName: "stories-list" */ '../views/discover/StoryList.vue');
    },
    meta: {
      level: 24,
    },
    name: 'stories_list',
  },
  {
    path: '/discover/stories/:id',
    component() {
      return import(/* webpackChunkName: "stories-detail" */ '../views/discover/StoryDetail.vue');
    },
    meta: {
      level: 34,
    },
    name: 'stories_detail',
    props: true,
  },
  {
    path: '/discover/story-writer/:id',
    component() {
      return import(/* webpackChunkName: "stories-write" */ '../views/discover/StoryWriter.vue');
    },
    meta: {
      level: 44,
    },
    name: 'stories_writer',
    props: true,
  },
  {
    path: '/discover/jokes',
    component() {
      return import(/* webpackChunkName: "jokes" */ '../views/discover/Joke.vue');
    },
    meta: {
      level: 41,
    },
    name: 'joke',
  },

  {
    path: '/discover/sizes-list',
    component() {
      return import(/* webpackChunkName: "sizes-list" */ '../views/discover/SizesList.vue');
    },
    meta: {
      level: 27,
    },
    name: 'sizes_list',
  },

  {
    path: '/discover/positions-categories',
    component() {
      return import(/* webpackChunkName: "position-categories" */ '../views/discover/PositionsCategoryList.vue');
    },
    meta: {
      level: 30,
    },
    name: 'position-categories',
  },
  {
    path: '/discover/positions',
    component() {
      return import(/* webpackChunkName: "positions" */ '../views/discover/PositionsList.vue');
    },
    meta: {
      level: 34,
    },
    name: 'positions',
    props: true,
  },
  {
    path: '/discover/positions/:id',
    component() {
      return import(/* webpackChunkName: "position-detail" */ '../views/discover/PositionDetail.vue');
    },
    meta: {
      level: 44,
    },
    name: 'position-detail',
    props: true,
  },

  /*** DREAM ***/
  {
    path: '/dream',
    component() {
      return import(/* webpackChunkName: "dream" */ '../views/Dream.vue');
    },
    meta: {
      level: 16,
    },
    name: 'dream',
  },
  {
    path: '/dream/bucket-list',
    component() {
      return import(/* webpackChunkName: "bucket-list" */ '../views/dream/BucketList.vue');
    },
    meta: {
      level: 21,
    },
    name: 'bucket_list',
  },
  {
    path: '/dream/love-list',
    component() {
      return import(/* webpackChunkName: "love-list" */ '../views/dream/LoveList.vue');
    },
    meta: {
      level: 22,
    },
    name: 'love_list',
  },
  {
    path: '/dream/memories-list',
    component() {
      return import(/* webpackChunkName: "memories-list" */ '../views/dream/MemoriesList.vue');
    },
    meta: {
      level: 23,
    },
    name: 'memories_list',
  },
  {
    path: '/dream/fantasies-list',
    component() {
      return import(/* webpackChunkName: "fantasies-list" */ '../views/dream/FantasiesList.vue');
    },
    meta: {
      level: 24,
    },
    name: 'fantasies_list',
  },
  {
    path: '/dream/fantasy-escapes',
    component() {
      return import(/* webpackChunkName: "fantasy-escapes" */ '../views/dream/escapes/EscapesList.vue');
    },
    meta: {
      level: 25,
    },
    name: 'escapes_list',
  },
  {
    path: '/dream/fantasy-escapes/detail',
    component() {
      return import(/* webpackChunkName: "fantasy-escapes-detail" */ '../views/dream/escapes/EscapesDetail.vue');
    },
    meta: {
      level: 31,
    },
    name: 'escapes_detail',
    props: true,
  },
  {
    path: '/dream/reminders',
    component() {
      return import(/* webpackChunkName: "reminders" */ '../views/dream/Reminders.vue');
    },
    meta: {
      level: 26,
    },
    name: 'reminders',
  },
  {
    path: '/dream/calendar',
    component() {
      return import(/* webpackChunkName: "calendar" */ '../views/dream/calendar/Calendar.vue');
    },
    meta: {
      level: 27,
    },
    name: 'calendar',
  },
  {
    path: '/dream/conquests',
    component() {
      return import(/* webpackChunkName: "conquests" */ '../views/dream/Conquests.vue');
    },
    meta: {
      level: 28,
    },
    name: 'conquests',
  },
  /*** LEARN ***/
  {
    path: '/learn/:categoryId?',
    component() {
      return import(/* webpackChunkName: "learn" */ '../views/Learn.vue');
    },
    meta: {
      level: 18,
    },
    name: 'learn',
    props: true,
  },
  {
    path: '/learn/article/:id',
    component() {
      return import(/* webpackChunkName: "learn-article" */ '../views/learn/ArticleDetail.vue');
    },
    meta: {
      level: 22,
    },
    name: 'learn_article',
    props: true,
  },
  {
    path: '/learn/expertqa',
    component() {
      return import(/* webpackChunkName: "expertqa" */ '../views/learn/ExpertQA.vue');
    },
    meta: {
      level: 23,
    },
    name: 'expertqa',
  },
  {
    path: '/learn/expertqa/question/:id',
    component() {
      return import(/* webpackChunkName: "expertqa-detail" */ '../views/learn/ExpertQADetail.vue');
    },
    meta: {
      level: 31,
    },
    name: 'expertqa_detail',
    props: true,
  },
  /*** CHAT ***/
  {
    path: '/chat',
    component() {
      return import(/* webpackChunkName: "chat" */ '../views/Chat.vue');
    },
    meta: {
      level: 19,
    },
    name: 'chat',
  },
  /*** OTHER ***/
  {
    path: "/sign_up",
    component() {
      return import(/* webpackChunkName: "signup" */ "../views/users/SignUp.vue");
    },
    meta: {
      allowAnonymous: true,
      level: 41,
    },
    name: "sign_up",
  },
  {
    path: "/request_push_perms",
    component() {
      return import(/* webpackChunkName: "request_push_perms" */ "../views/users/RequestPushPerms.vue");
    },
    name: "request_push_perms",
    meta: {
      level: 41,
    }
  },
  {
    path: "/login",
    component() {
      return import(/* webpackChunkName: "login" */ "../views/users/Login.vue");
    },
    meta: {
      allowAnonymous: true,
      level: 9,
    },
    name: "login"
  },
  {
    path: "/logout",
    component() {
      return import(/* webpackChunkName: "logout" */ "../views/users/Logout.vue");
    },
    meta: {
      allowAnonymous: true,
      level: 41,
    },
    name: "logout",
  },
  {
    path: "/password_change",
    component() {
      return import(/* webpackChunkName: "passwordchange" */ "../views/users/PasswordChange.vue");
    },
    name: "password_change",
    meta: {
      level: 41,
    }
  },
  {
    path: "/password_reset",
    component() {
      return import(/* webpackChunkName: "passwordreset" */ "../views/users/PasswordReset.vue");
    },
    meta: {
      allowAnonymous: true,
      level: 41,
    },
    name: "password_reset",
  },
  {
    path: "/profile_update",
    component() {
      return import(/* webpackChunkName: "profileupdate" */ "../views/users/ProfileUpdate.vue");
    },
    props: true,
    name: "profile_update",
    meta: {
      level: 42,
    }
  },
  {
    path: "/profile_photo_change",
    component() {
      return import(/* webpackChunkName: "profilephotochange" */ "../views/users/ProfilePhotoChange.vue");
    },
    props: true,
    name: "profile_photo_change",
    meta: {
      level: 41,
    }
  },
  {
    path: "/background_photo_change",
    component() {
      return import(/* webpackChunkName: "backgroundphotochange" */ "../views/users/BackgroundPhotoChange.vue");
    },
    props: true,
    name: "background_photo_change",
    meta: {
      level: 41,
    }
  },
  {
    path: "/invite_spouse",
    component() {
      return import(/* webpackChunkName: "invitespouse" */ "../views/users/InviteSpouse.vue");
    },
    props: true,
    name: "invite_spouse",
    meta: {
      level: 41,
    }
  },
  {
    path: "/inapppurchase",
    component() {
      return import(/* webpackChunkName: "inapppurchase" */ "../views/InAppPurchase.vue");
    },
    props: true,
    name: "inapppurchase",
    meta: {
      level: 41,
    }
  },
  {
    path: "/restore",
    component() {
      return import(/* webpackChunkName: "restore" */ "../views/RestorePurchases.vue");
    },
    name: "restore_purchases",
    meta: {
      level: 41,
    }
  },
  {
    path: "/sync",
    component() {
      return import(/* webpackChunkName: "sync" */ "../views/Sync.vue");
    },
    name: "sync",
    meta: {
      level: 41,
    }
  },
  {
    path: "/settings",
    component() {
      return import(/* webpackChunkName: "settings" */ "../views/Settings.vue");
    },
    name: "settings",
    meta: {
      level: 21,
    }
  },
  {
    path: "/badges",
    component() {
      return import(/* webpackChunkName: "badges" */ "../views/Badges.vue");
    },
    name: "badges",
    meta: {
      level: 21,
    }
  },
  {
    path: "/intimacy-score",
    component() {
      return import(/* webpackChunkName: "intimacy_score" */ "../views/IntimacyScore.vue");
    },
    name: "intimacy_score",
    meta: {
      level: 21,
    }
  },
  {
    path: "/page/:slug",
    component() {
      return import(/* webpackChunkName: "flatpage" */ "../views/Flatpage.vue");
    },
    meta: {
      allowAnonymous: true,
      level: 40,
    },
    props: true,
    name: "flatpage"
  },
  {
    path: "/whats-new",
    component() {
      return import(/* webpackChunkName: "whatsnew" */ "../views/WhatsNew.vue");
    },
    name: "whats_new",
    meta: {
      level: 41,
    }
  },
  {
    path: "/feedback",
    component() {
      return import(/* webpackChunkName: "feedback" */ "../views/Feedback.vue");
    },
    name: "feedback",
    meta: {
      level: 41,
    }
  },
  {
    path: "/share",
    component() {
      return import(/* webpackChunkName: "share" */ "../views/Share.vue");
    },
    name: "share",
    meta: {
      level: 42,
    }
  },
  {
    path: "/leaderboard",
    component() {
      return import(/* webpackChunkName: "leaderboard" */ "../views/Leaderboard.vue");
    },
    name: "leaderboard",
    meta: {
      level: 43,
    }
  },
  {
    path: "/sextember",
    component() {
      return import(/* webpackChunkName: "sextember" */ "../views/us/Sextember.vue");
    },
    name: "sextember",
    meta: {
      level: 44,
    }
  },
  {
    path: "*",
    component() {
      return import(/* webpackChunkName: "404" */ "../views/PageNotFound.vue");
    },
    meta: { allowAnonymous: true },
    name: "page_not_found"
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // eslint-disable-line no-unused-vars
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (
    from.name !== null &&
    document.body.classList.contains('security-wall-modal-open')
  ) {
    // It appears that the user has tapped their (Android) device's back
    // button. We should ignore that.

    next(false);
    return;
  }

  store.commit("latestFromRoute", from);

  if (to.matched.some(record => record.meta.allowAnonymous)) {
    next();
  } else {
    if (store.state.userData === null) {
      next({
        name: "login",
        query: { next: to.fullPath }
      });
    } else {
      // Put in-app purchase logic stuff here, Only allow routes that are free. Otherwise
      // direct the user to In App Purchase screen.
      next();
    }
  }
});

router.afterEach((to) => {
  try {
    if (window.FirebasePlugin) {
      window.FirebasePlugin.setScreenName(to.path);
    }
  }
  catch (e) {} // eslint-disable-line no-empty
});


export default router
